import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes',
)({
  component: function IntegracoesLayout() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <Outlet />
      </ProtectedRoute>
    )
  },
})
